document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });

  document.querySelectorAll('[data-option-choice]').forEach(function (choice) {
    choice.addEventListener('change', function () {
      var group = choice.closest('[data-product-option-group]');
      var select = group && group.querySelector('[data-option-selector]');
      if (!select) return;
      select.value = choice.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-option-selector]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form[action*="/cart/add"]');
      var button = form && form.querySelector('.product-form__submit');
      if (!button) return;
      window.requestAnimationFrame(function () {
        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
      });
    });
  });

  document.querySelectorAll('[data-product-thumbnail]').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      var gallery = thumbnail.closest('[data-product-gallery]');
      var mainImage = gallery && gallery.querySelector('.product-gallery__main');
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.imageUrl;
      mainImage.srcset = '';
      mainImage.alt = thumbnail.dataset.imageAlt || '';
      gallery.querySelectorAll('[data-product-thumbnail]').forEach(function (item) { item.classList.remove('is-active'); });
      thumbnail.classList.add('is-active');
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.nav-dropdown[open]').forEach(function (dropdown) {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });
});
